var myChart = echarts.init(document.getElementById("skills"));

var option = {
    tooltip: {},
    radar: {
        shape: "circle",
        name: {
            textStyle: {
                color: "#fff",
                backgroundColor: "#999",
                borderRadius: 3,
                padding: [3, 5],
            },
        },
        nameGap: 0,
        indicator: [
            { name: "Page", max: 100 },
            { name: "React", max: 100 },
            { name: "Vue", max: 100 },
            { name: "node.js", max: 100 },
            { name: "linux", max: 100 },
            { name: "Comm.", max: 100 },
        ],
    },
    series: [
        {
            name: "Skills Radar",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
                {
                    //   依次 静态页面..
                    value: [100, 94, 80, 72, 76, 90],
                    name: "Skills Radar",
                },
            ],
        },
    ],
};

myChart.setOption(option);
